import React, { useContext, useState } from "react";
import { Icon } from "../../../../components/Component";
import { FileManagerContext } from "../FileManagerContext";
import { Input } from "reactstrap";
import { servicePutFile } from "services/file";
import Swal from "sweetalert2";

const Rename = ({ file, toggle, toggleCreateModal, cookies, departmentId }) => {
  const { refresh } = useContext(FileManagerContext);

  // const [name, setName] = useState(file.name.replace('.'+file.extension, ''))
  const [name, setName] = useState(() => {
    const lastDotIndex = file.name.lastIndexOf('.');
    return lastDotIndex !== -1 ? file.name.substring(0, lastDotIndex) : file.name;
  });

  const handleEdit = async (name) => {
    const resp = await servicePutFile(file.id, cookies.SIDikey, {name: name + '.'+file.extension} );
    if(resp.status === 202){
      refresh();
    }else{
      Swal.fire('error', 'Gagal Rename, mohon refresh', 'error')
    }
  };

  return (
    <React.Fragment>
      <div className="modal-header align-center border-bottom-0">
        <h6 className="modal-title">Rename File</h6>
        <a
          href="#close"
          onClick={(ev) => {
            ev.preventDefault();
            toggle();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
      </div>
      <div className="modal-body pt-0 mt-n2">
     
        <div className="nk-fmg-listing is-scrollable mt-5">
          <div className="nk-files nk-files-view-list is-compact">
            <div className="nk-files-list">
              <Input defaultValue={name} name="name" onChange={(ev) => setName(ev.target.value)}></Input>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer bg-light">
        <div className="modal-footer-between">
          <div className="g">
        
          </div>
          <div className="g">
            <ul className="btn-toolbar g-3">
              <li>
                <a
                  href="#file-share"
                  onClick={(ev) => {
                    ev.preventDefault();
                    toggle();
                  }}
                  className="btn btn-outline-light btn-white"
                >
                  Cancel
                </a>
              </li>
              <li>
                <a
                  href="link"
                  onClick={(ev) => {
                    ev.preventDefault();
                    handleEdit(name);
                    toggle();
                  }}
                  className="btn btn-primary file-dl-toast"
                >
                  Save
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Rename;
